import {
  arrayOf as arrayType,
  params,
  string as stringType,
  extend,
  customType
} from '@thd-nucleus/data-sources';
import { VisualCategoryNavigation } from '@thd-olt-component-react/visual-category-navigation';
import { SpecialBuyBanner } from '@thd-olt-component-react/special-buy-banner';
import { RecommendationsPlaceholder } from '@thd-olt-component-react/recommendations';
import { dataModel as dpdSearchModel } from '../hooks/dpdDataModel';

export const dataModel = extend({
  searchModel: params({ keyword: stringType(), storeId: stringType(), navParam: stringType() }).shape({
    templates: arrayType(stringType()),
    partialTemplates: arrayType(stringType())
  }),
  content: params({ name: stringType().isRequired(),
    channel: customType('Channel').enum(['DESKTOP', 'MOBILE', 'TABLET'], 'DESKTOP') }).shape({
    templates: arrayType(stringType())
  })
},
VisualCategoryNavigation,
dpdSearchModel,
SpecialBuyBanner,
RecommendationsPlaceholder
);
